<div class="modal-card">
  <div class="icon-container">
    <button type="button" class="close-x" aria-label="Close" (click)="cancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="body-container">
    <div class="text-container">
      <h3 class="modal-title">You're About to Leave the HRSA Data Warehouse Website</h3>
      <p class="modal-body">
        You are now leaving the HRSA Data Warehouse and will be redirected to an external site. 
        Hyperlinks embedded in this tool were generated from submissions to HRSA from external entities. 
        As such, HRSA does not control the referenced website and is not responsible for the content, 
        security, or privacy practices of that site.
      </p>
      <p class="modal-body">
        By clicking "Continue," you acknowledge that you are leaving the HRSA Data Warehouse and 
        visiting a third-party site. We make no warranties regarding the accuracy, safety, or 
        reliability of the external content. Your use of that site is entirely at your own risk.
      </p>
    </div>
    <div class="button-container">
      <button type="button" class="btn-secondary" (click)="cancel()">Back</button>
      <button type="button" class="btn-primary" (click)="continue()">Continue</button>
    </div>
  </div>
</div>
